/* eslint-disable react/destructuring-assignment,react/prop-types,react/require-default-props,react/no-unused-prop-types,prefer-destructuring,react/forbid-prop-types,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions,react/default-props-match-prop-types */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';
import { connect } from 'react-redux';
import $ from 'jquery';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCog,
  faCopy,
  faFileCertificate,
  faGift,
  faHistory,
  faQuestionCircle,
  faRedo,
  faSignOutAlt,
  faUserCircle,
} from '@fortawesome/pro-regular-svg-icons';
import {
  selectCurrentPortalWhiteLabelLogoImageUrl,
  selectCurrentPortalWhiteLabelLogoEnabled,
} from 'src/ReduxStorage/Portal/selectors';
import { WhiteLabelVisibilitySettingNames } from 'src/ReduxStorage/Portal/types';
import { fetchUserSubscriptionPlans } from 'src/ReduxStorage/UserSubscriptionPlans/dispatchers';
import {
  selectCurrentUserSubscriptionPlans,
  selectCurrentUserSubscriptionPlansHasLoaded,
} from 'src/ReduxStorage/UserSubscriptionPlans/selectors';
import { Link } from '../Link/index';
import { topBarContainer } from './styles.scss';
import { CircleProfilePicture } from '../../components/CircleProfilePicture/CircleProfilePicture';
import { ConnectedLoginModal as LoginModal } from '../LoginModal/LoginModal';
import { SiteNavigationMenu } from '../../components/Navigation/SiteNavigationMenu/index';
import { CourseNavigationMenu } from '../../components/Navigation/CourseNavigationMenu/index';
import {
  selectFilteredCohortsByCreatorOrInstitution,
  selectShowForInstitutionsLink,
} from './selectors';
import { selectOpenModuleSet } from '../../../ReduxStorage/Courses/ModuleDisplay/selectors';
import { selectNumUnreadConversations } from '../../../ReduxStorage/Chat/selectors';
import { currentUserSelector } from '../../../ReduxStorage/Users/selectors';
import { makeTopbarSearchSubmit, loadCurrentUser } from './dispatchers';
import {
  loginRequired,
  logout,
  getEnrolledClassData,
} from '../../../ReduxStorage/Auth/dispatchers';
import { retrieveNumUnreadMessages } from '../../../ReduxStorage/Chat/dispatchers';
import {
  selectHasRequestedEnrolledClassData,
  currentUserIdSelector,
  selectHasFetchedEnrolledClassData,
} from '../../../ReduxStorage/Auth/selectors';
import {
  selectCurrentCoursePath,
  isCurrentCourseRTLSelector,
  selectIsInCourse,
} from '../../../ReduxStorage/Courses/selectors';
import {
  selectIsAdminOfCurrentInstitution,
  selectCurrentInstitution,
} from '../../../ReduxStorage/Institutions/selectors';
import { retrieveInstitutions } from '../../../ReduxStorage/Institutions/dispatchers';

import { FontAwesome } from '../../components/FontAwesome';
import { showUploadProfilePhotoModal } from '../../components/UploadProfilePhotoModal/loadable';
import { ImmutableUser } from '../../../CustomPropTypes/UserPropTypes';
import { ImmutableInstitution } from '../../../CustomPropTypes/InstitutionPropTypes';
import { NotificationStore } from '../../data/stores/NotificationStore';
import { NotificationInitialiser } from '../../data/initialisers/NotificationInitialiser';
import { NotificationClientActionCreators } from '../../data/actions/NotificationClientActionCreators';
import { NotificationActions } from '../../data/constants/NotificationActions';
import {
  selectLoginLink,
  selectSignupLink,
} from '../../../ReduxStorage/Auth/Login/selectors';

import {
  ROUTE_INSTITUTION_ADMIN,
  ROUTE_USER_PROFILE_PAGE,
  ROUTE_ACCOUNTS_SUBSCRIPTIONS,
  ROUTE_ACCOUNTS_SETTINGS,
  ROUTE_HOMEPAGE,
  ROUTE_ACCOUNTS_UNKNOWN,
  ROUTE_SSO,
} from '../../../ReduxStorage/routeActions';

import {
  TOPBAR_EXPANDED_USER,
  TOPBAR_EXPANDED_NOTIFICATIONS,
  TOPBAR_EXPANDED_NAV,
  TOPBAR_EXPANDED_SETTINGS,
  TOPBAR_EXPANDED_MOBILE_NAV,
  TOPBAR_DROPDOWN_ALIGN_RIGHT,
  TOPBAR_DROPDOWN_ALIGN_LEFT,
} from '../../../ReduxStorage/TopBar/constants';

import {
  updateTopBarSiteNavRendered,
  clearTopBarExpendedMenu,
} from '../../../ReduxStorage/TopBar/dispatchers';
import {
  selectTopBarExpandedMenu,
  selectTopBarItemVisibilities,
  selectTopBarSiteNavRendered,
} from '../../../ReduxStorage/TopBar/selectors';

// import { TopBarButton } from './TopBarButton/component';
import { ConnectorTopBarButton } from './TopBarButton/connector';
import { ConnectorTopBarDropdown } from './TopBarDropdown/connector';
import {
  getAnnouncements,
  openAnnouncements,
} from '../../../ReduxStorage/PlatformAnnouncements/dispatchers';
import {
  selectPlatformAnnouncementsLoading,
  selectPlatformAnnouncementsPosts,
  selectPlatformAnnouncementsError,
} from '../../../ReduxStorage/PlatformAnnouncements/selectors';
import { selectIsInAppWebview } from '../../../ReduxStorage/location/selectors';
import { NotificationsDropdownContents } from './NotificationsDropdown/NotificationsDropdownContents';
import { HELP_ORIGIN } from '../../../constants';
import { ChooseLanguageSelect } from '../../components/ChooseLanguageSelect/component';
import { updateUserPreferredLanguage } from '../../../ReduxStorage/Users/dispatchers.web';
import { LinkProvider } from '../../components/Contexts/LinkContext';
import { RouteLink } from '../../components/RouteLink/component';
import { selectCurrentPortal } from '../../../ReduxStorage/Portal/selectors';
import {
  getPortalExternalLogInLink,
  getPortalExternalSignUpLink,
} from '../../../ReduxStorage/Portals/helpers';
import { selectType } from '../../../ReduxStorage/location/selectors.common';

/* global _OL_ORIGIN */

class AnnouncementsMenu extends PureComponent {
  componentDidMount() {
    // wait a bit for the currentUser data to get into the redux store
    setTimeout(this.props.onMount, 100);
  }

  render() {
    const { loading, posts, onClick } = this.props;
    if (loading) {
      return null;
    } else if (posts > 0) {
      return (
        <li role="menuitem">
          <ConnectorTopBarButton
            icon={<FontAwesome name="gift" />}
            label="Announcements"
            onClick={onClick}
          />
        </li>
      );
    } else {
      return null;
    }
  }
}

const ConnectedAnnouncementsMenu = connect(
  (state) => {
    return {
      loading: selectPlatformAnnouncementsLoading(state),
      error: selectPlatformAnnouncementsError(state),
      posts: selectPlatformAnnouncementsPosts(state),
    };
  },
  (dispatch) => ({
    onMount: () => dispatch(getAnnouncements),
    onClick: () => {
      dispatch(clearTopBarExpendedMenu);
      dispatch(openAnnouncements);
    },
  })
)(AnnouncementsMenu);

class InstitutionSettingsMenu extends PureComponent {
  static propTypes = {
    currentInstitution: ImmutableInstitution.isRequired,
  };

  render() {
    return (
      <ul className="top-bar-institution-settings-menu">
        <li>
          <RouteLink
            to={{
              type: ROUTE_INSTITUTION_ADMIN,
              query: {
                institution: this.props.currentInstitution.get('path'),
              },
            }}
            className="top-bar-institution-settings-menu-link"
          >
            <FontAwesome name="cog" />
            Institution Settings
          </RouteLink>
        </li>
      </ul>
    );
  }
}

class _NotificationsMenuItem extends PureComponent {
  static propTypes = {
    onClick: PropTypes.func,
    initialiseFluxNotifications: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      numUnreadNotifications: NotificationStore.getUnreadCount(),
      numUnreadNotificationsIsUnderEstimate: NotificationStore.isUnreadCountUnderestimate(),
    };
  }

  componentDidMount() {
    NotificationStore.registerChangeCallback(
      this.updateUnreadNotificationCount
    );
    this.props.initialiseFluxNotifications();
  }

  componentWillUnmount() {
    NotificationStore.unregisterChangeCallback(
      this.updateUnreadNotificationCount
    );
  }

  updateUnreadNotificationCount = () => {
    this.setState({
      numUnreadNotifications: NotificationStore.getUnreadCount(),
      numUnreadNotificationsIsUnderEstimate: NotificationStore.isUnreadCountUnderestimate(),
    });
  };

  ensureNotificationsAvailable = () => {
    if (
      !NotificationStore.hasStartedLoadingNotifications(
        NotificationActions.ACTION_ALL,
        true
      )
    ) {
      NotificationClientActionCreators.loadMoreNotifications(
        NotificationActions.ACTION_ALL,
        true
      );
    }
  };

  render() {
    return (
      <ConnectorTopBarButton
        icon={<span className={classnames('topbar-icon-ol-outline-notify')} />}
        label="Notifications"
        menu={TOPBAR_EXPANDED_NOTIFICATIONS}
        onClick={this.ensureNotificationsAvailable}
        badge={
          this.state.numUnreadNotifications > 0 ? (
            <span>
              {this.state.numUnreadNotifications}
              {this.state.numUnreadNotificationsIsUnderEstimate && '+'}
            </span>
          ) : null
        }
      />
    );
  }
}

const NotificationsMenuItem = connect(undefined, {
  initialiseFluxNotifications: NotificationInitialiser.initialise,
})(_NotificationsMenuItem);

const NotificationsMenu = () => (
  <div className="notifications-dropdown-contents-wrapper">
    <NotificationsDropdownContents />
  </div>
);

NotificationsMenu.propTypes = {
  expanded: PropTypes.bool,
};

class _UserSettingsMenu extends PureComponent {
  static propTypes = {
    activeUser: ImmutableUser,
    activeUserId: PropTypes.string.isRequired,
    currentInstitution: ImmutableInstitution,
    numUnreadConversations: PropTypes.number.isRequired,
    onLogout: PropTypes.func.isRequired,
    retrieveNumUnreadMessages: PropTypes.func.isRequired,
    currentUserSubscriptionPlans: PropTypes.object,
  };

  constructor(props) {
    super(props);
    if (props.activeUserId) {
      props.retrieveNumUnreadMessages();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.activeUserId !== nextProps.activeUserId) {
      this.props.retrieveNumUnreadMessages();
    }
  }

  getHelpLink = () => {
    if (
      this.props.currentInstitution &&
      this.props.currentInstitution.get('hasCustomHelpPage')
    ) {
      return `${this.props.currentInstitution.get('url')}/help`;
    } else {
      return `${_OL_ORIGIN}/sso/help/`;
    }
  };

  onOpenChangeProfilePicture = () => {
    const { clearTopBarExpendedMenu: closeDropdown } = this.props;
    closeDropdown();
    showUploadProfilePhotoModal();
  };

  onWhatsNewClick = () => {
    const { clearTopBarExpendedMenu: closeDropdown } = this.props;
    closeDropdown();
    openAnnouncements();
  };

  render() {
    const props = this.props;
    const { topBarItemVisibilities } = props;
    const {
      [WhiteLabelVisibilitySettingNames.isAccountMenuProfileVisible]: isAccountMenuProfileVisible,
      [WhiteLabelVisibilitySettingNames.isAccountMenuInformationVisible]: isAccountMenuInformationVisible,
      [WhiteLabelVisibilitySettingNames.isAccountMenuChatHistoryVisible]: isAccountMenuChatHistoryVisible,
    } = topBarItemVisibilities;

    return (
      <ul className="top-bar-user-menu">
        {props.activeUser && isAccountMenuProfileVisible && (
          <>
            <li>
              <span className="menu-item-section-header">Profile</span>
            </li>
            <li>
              <RouteLink
                to={{
                  type: ROUTE_USER_PROFILE_PAGE,
                  params: {
                    profileName: props.activeUser.get('profileName'),
                  },
                }}
                className="top-bar-user-menu-link"
              >
                <FontAwesomeIcon icon={faUserCircle} />
                About me
              </RouteLink>
            </li>
            <li>
              <RouteLink
                to={{
                  type: ROUTE_USER_PROFILE_PAGE,
                  params: {
                    profileName: props.activeUser.get('profileName'),
                    page: 'portfolio',
                  },
                }}
                className="top-bar-user-menu-link"
              >
                <FontAwesomeIcon icon={faCopy} />
                Portfolio
              </RouteLink>
            </li>
            <li>
              <RouteLink
                to={{
                  type: ROUTE_USER_PROFILE_PAGE,
                  params: {
                    profileName: props.activeUser.get('profileName'),
                    page: 'credentials',
                  },
                }}
                className="top-bar-user-menu-link"
              >
                <FontAwesomeIcon icon={faFileCertificate} />
                Credentials
              </RouteLink>
            </li>
            <hr className="top-bar-menu-divider" />
          </>
        )}
        {isAccountMenuInformationVisible && (
          <>
            <li>
              <span className="menu-item-section-header">Information</span>
            </li>
            <li>
              <RouteLink
                to={{
                  type: ROUTE_SSO,
                  params: { action: 'help' },
                  query: {
                    url: `${HELP_ORIGIN}/`,
                  },
                }}
                className="top-bar-user-menu-link"
              >
                <FontAwesomeIcon icon={faQuestionCircle} />
                Help & Support
              </RouteLink>
            </li>
            <li>
              <button
                type="button"
                className="top-bar-user-menu-link"
                onClick={this.onWhatsNewClick}
              >
                <FontAwesomeIcon icon={faGift} />
                {"What's new"}
              </button>
            </li>
            <hr className="top-bar-menu-divider" />
          </>
        )}

        <li>
          <span className="menu-item-section-header">Account</span>
        </li>
        {props.currentUserSubscriptionPlans &&
          props.currentUserSubscriptionPlans.size > 0 && (
            <li>
              <RouteLink
                to={{
                  type: ROUTE_ACCOUNTS_SUBSCRIPTIONS,
                }}
                className="top-bar-user-menu-link"
              >
                <FontAwesomeIcon icon={faRedo} />
                Manage subscriptions
              </RouteLink>
            </li>
          )}
        <li>
          <RouteLink
            to={{
              type: ROUTE_ACCOUNTS_SETTINGS,
            }}
            className="top-bar-user-menu-link"
          >
            <FontAwesomeIcon icon={faCog} />
            Account Settings
          </RouteLink>
        </li>
        {isAccountMenuChatHistoryVisible && (
          <li>
            <RouteLink
              to={{
                type: ROUTE_ACCOUNTS_UNKNOWN,
                params: {
                  subPath: 'conversations',
                },
              }}
              className={classnames('top-bar-user-menu-link', {
                'top-bar-user-menu-link-highlight':
                  props.numUnreadConversations > 0,
              })}
            >
              <FontAwesomeIcon icon={faHistory} />
              Chat History{' '}
              {props.numUnreadConversations > 0 && (
                <span>({props.numUnreadConversations})</span>
              )}
            </RouteLink>
          </li>
        )}

        <li>
          <button
            type="button"
            className="top-bar-user-menu-link"
            onClick={props.onLogout}
          >
            <FontAwesomeIcon icon={faSignOutAlt} />
            Log out
          </button>
        </li>
      </ul>
    );
  }
}
const UserSettingsMenu = connect(
  (state) => ({
    activeUserId: currentUserIdSelector(state),
    activeUser: currentUserSelector(state),
    currentInstitution: selectCurrentInstitution(state),
    numUnreadConversations: selectNumUnreadConversations(state),
    currentUserSubscriptionPlans: selectCurrentUserSubscriptionPlans(state),
  }),
  (dispatch) => ({
    onLogout: () => {
      dispatch(logout()).then(() => window.location.reload());
    },
    retrieveNumUnreadMessages: () => dispatch(retrieveNumUnreadMessages()),
    clearTopBarExpendedMenu: () => dispatch(clearTopBarExpendedMenu()),
  })
)(_UserSettingsMenu);

const TopBarLeft = () => (
  <div className="top-bar-left">
    <ul className={classnames('top-bar-menu')} data-dropdown-menu>
      <li
        className={classnames({
          'top-bar-item': true,
        })}
      >
        <ConnectorTopBarButton
          icon={<FontAwesome name="bars" />}
          label="Mobile navigation"
          menu={TOPBAR_EXPANDED_MOBILE_NAV}
        />
        <ConnectorTopBarDropdown
          menu={TOPBAR_EXPANDED_MOBILE_NAV}
          defaultAlignment={TOPBAR_DROPDOWN_ALIGN_LEFT}
        >
          <div className="top-bar-course-nav-dropdown">
            <CourseNavigationMenu mobile />
          </div>
        </ConnectorTopBarDropdown>
      </li>
    </ul>
  </div>
);

class TopBarRight extends PureComponent {
  static propTypes = {
    currentCoursePath: PropTypes.string,
    onLogin: PropTypes.func.isRequired,
    activeUser: ImmutableUser,
    activeUserId: PropTypes.string,
    // activeInstitution: Institution,
    // activeEnrolment: Enrolment,
    isInstitutionAdmin: PropTypes.bool.isRequired,
    cohortsByCourseCreator: PropTypes.array,
    hasFetchedEnrolledClassData: PropTypes.bool,
    hasRequestedEnrolledClassData: PropTypes.bool,
    small: PropTypes.bool.isRequired,
    showLoginModal: PropTypes.bool.isRequired,
    loginLinkAction: PropTypes.object.isRequired,
    signupLinkAction: PropTypes.object.isRequired,
    expandedMenu: PropTypes.string,
    updateTopBarSiteNavRendered: PropTypes.func.isRequired,
    siteNavRendered: PropTypes.bool.isRequired,
    showForInstitutionsLink: PropTypes.bool.isRequired,
    onSaveLanguage: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    externalSignUpLink: PropTypes.string,
    externalLogInLink: PropTypes.string,
    getEnrolledClassData: PropTypes.func.isRequired,
    whiteLabelLogoImageUrl: PropTypes.string,
    topBarItemVisibilities: PropTypes.object.isRequired,
    currentUserSubscriptionPlansHasLoaded: PropTypes.bool.isRequired,
    fetchUserSubscriptionPlans: PropTypes.func.isRequired,
  };

  onClickLogin = (e) => {
    if (this.props.showLoginModal) {
      e.preventDefault();
      this.props.onLogin('login');
    }
  };

  onClickSignup = (e) => {
    if (this.props.showLoginModal) {
      e.preventDefault();
      this.props.onLogin('signup');
    }
  };

  onClickCourses = async () => {
    await this.props.getEnrolledClassData();
    this.props.updateTopBarSiteNavRendered(true);
  };

  onSearchSubmit = (event) => {
    const searchString = $(event.currentTarget).find('input')[0].value;
    this.props.topbarSearchSubmit(searchString);
  };

  onProfileClick = () => {
    const {
      currentUserSubscriptionPlansHasLoaded,
      fetchUserSubscriptionPlans,
    } = this.props;

    if (!currentUserSubscriptionPlansHasLoaded) {
      fetchUserSubscriptionPlans();
    }
  };

  render() {
    const props = this.props;
    const { topBarItemVisibilities } = props;
    const {
      [WhiteLabelVisibilitySettingNames.isSearchVisible]: isSearchVisible,
      [WhiteLabelVisibilitySettingNames.isCourseNavigationVisible]: isCourseNavigationVisible,
      [WhiteLabelVisibilitySettingNames.isLanguageSelectorVisible]: isLanguageSelectorVisible,
    } = topBarItemVisibilities;

    return (
      <div className={classnames('top-bar-right')}>
        {isSearchVisible && (
          <form
            className="top-bar-search-form"
            action={`${_OL_ORIGIN}/search/`}
            onSubmit={this.onSearchSubmit}
            method="get"
          >
            <label
              className="top-bar-search-label"
              htmlFor="top-bar-search-text"
            >
              Search
            </label>
            <input
              id="top-bar-search-text"
              className="top-bar-search-text"
              type="search"
              name="q"
              placeholder="Search"
              required
            />
            <button className="top-bar-search-submit" type="submit">
              <FontAwesome name="search" />
              <span className="top-bar-search-submit-text">Search</span>
            </button>
          </form>
        )}

        {isLanguageSelectorVisible && (
          <ChooseLanguageSelect
            currentLanguage={props.activeUser?.get('preferredLanguage')}
            onSave={this.props.onSaveLanguage}
          />
        )}
        {props.activeUserId && (
          <ul
            className={classnames('top-bar-menu')}
            role="menu"
            data-dropdown-menu
          >
            {props.activeUser && <ConnectedAnnouncementsMenu />}
            {props.isInstitutionAdmin && (
              <li role="menuitem">
                <ConnectorTopBarButton
                  icon={<span className="topbar-icon-ol-solid-cog" />}
                  label="Settings"
                  menu={TOPBAR_EXPANDED_SETTINGS}
                />
                <ConnectorTopBarDropdown
                  menu={TOPBAR_EXPANDED_SETTINGS}
                  defaultAlignment={TOPBAR_DROPDOWN_ALIGN_RIGHT}
                >
                  <InstitutionSettingsMenu
                    currentInstitution={props.currentInstitution}
                  />
                </ConnectorTopBarDropdown>
              </li>
            )}
            <li role="menuitem">
              <NotificationsMenuItem />
              <ConnectorTopBarDropdown
                menu={TOPBAR_EXPANDED_NOTIFICATIONS}
                defaultAlignment={TOPBAR_DROPDOWN_ALIGN_RIGHT}
                className="topbar-notifications-menu-dropdown"
              >
                <NotificationsMenu />
              </ConnectorTopBarDropdown>
            </li>
            {isCourseNavigationVisible && (
              <li role="menuitem">
                <ConnectorTopBarButton
                  icon={<span className="topbar-icon-ol-outline-nav" />}
                  label="Courses"
                  menu={TOPBAR_EXPANDED_NAV}
                  onClick={this.onClickCourses}
                />
                <ConnectorTopBarDropdown
                  menu={TOPBAR_EXPANDED_NAV}
                  defaultAlignment={TOPBAR_DROPDOWN_ALIGN_RIGHT}
                  className="topbar-site-navigation-menu-dropdown"
                >
                  {props.siteNavRendered ? (
                    <SiteNavigationMenu
                      cohortsByCourseCreator={props.cohortsByCourseCreator}
                      hasFetchedEnrolledClassData={
                        this.props.hasFetchedEnrolledClassData
                      }
                      isVisible={props.expandedMenu === TOPBAR_EXPANDED_NAV}
                    />
                  ) : (
                    <div className="top-bar-site-nav-placehold">
                      <button
                        type="button"
                        onClick={() => {
                          props.updateTopBarSiteNavRendered(true);
                        }}
                      >
                        Load site navigation
                      </button>
                    </div>
                  )}
                </ConnectorTopBarDropdown>
              </li>
            )}

            <li role="menuitem">
              <ConnectorTopBarButton
                icon={
                  this.props.activeUser ? (
                    <CircleProfilePicture
                      user={props.activeUser.toJS()}
                      className={classnames('top-bar-profile-picture', {
                        small: props.small,
                      })}
                    />
                  ) : (
                    <div
                      className={classnames(
                        'top-bar-profile-picture-placehold',
                        {
                          small: props.small,
                        }
                      )}
                    />
                  )
                }
                label={
                  props.activeUser
                    ? props.activeUser.get('profileName')
                    : 'User Menu'
                }
                menu={TOPBAR_EXPANDED_USER}
                className="user-dropdown-button"
                onClick={this.onProfileClick}
              />
              <ConnectorTopBarDropdown
                menu={TOPBAR_EXPANDED_USER}
                defaultAlignment={TOPBAR_DROPDOWN_ALIGN_RIGHT}
              >
                <UserSettingsMenu
                  topBarItemVisibilities={topBarItemVisibilities}
                />
              </ConnectorTopBarDropdown>
            </li>
          </ul>
        )}
        {!props.activeUserId && (
          <ul
            className={classnames(
              'menu',
              'top-bar-menu',
              'top-bar-menu-signup'
            )}
          >
            {props.showForInstitutionsLink && (
              <li>
                <a
                  className="top-bar-menu-institutions-link"
                  href="https://hubs.ly/H0kDnP40"
                >
                  For Institutions
                </a>
              </li>
            )}
            <li>
              {props.externalSignUpLink ? (
                <a
                  className="top-bar-menu-login-link"
                  href={props.externalSignUpLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Sign up
                </a>
              ) : (
                <RouteLink
                  shouldDispatch={!this.props.showLoginModal}
                  to={this.props.signupLinkAction}
                  className="top-bar-menu-signup-link"
                >
                  <span onClick={this.onClickSignup}>
                    {this.props.t('sign_up')}
                  </span>
                </RouteLink>
              )}
            </li>
            <li>
              {props.externalLogInLink ? (
                <a
                  className="top-bar-menu-login-link"
                  href={props.externalLogInLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Login
                </a>
              ) : (
                <RouteLink
                  shouldDispatch={!this.props.showLoginModal}
                  to={this.props.loginLinkAction}
                  className="top-bar-menu-login-link"
                >
                  <span onClick={this.onClickLogin}>
                    {this.props.t('login')}
                  </span>
                </RouteLink>
              )}
            </li>
          </ul>
        )}
      </div>
    );
  }
}

class _OLTopBar extends PureComponent {
  static propTypes = {
    onSaveLanguageChoice: PropTypes.func.isRequired,
    onLogin: PropTypes.func.isRequired,
    getEnrolledClassData: PropTypes.func.isRequired,
    activeUser: ImmutableUser,
    activeUserId: PropTypes.string,
    currentCoursePath: PropTypes.string,
    currentInstitution: ImmutableInstitution,
    isInstitutionAdmin: PropTypes.bool.isRequired,
    hasFetchedEnrolledClassData: PropTypes.bool.isRequired,
    hasRequestedEnrolledClassData: PropTypes.bool.isRequired,
    cohortsByCourseCreator: PropTypes.array,
    currentModuleSet: PropTypes.string,
    fixed: PropTypes.bool.isRequired,
    small: PropTypes.bool.isRequired,
    showLoginModal: PropTypes.bool.isRequired,
    retrieveInstitutions: PropTypes.func.isRequired,
    loginLinkAction: PropTypes.object.isRequired,
    signupLinkAction: PropTypes.object.isRequired,
    isCourseRTL: PropTypes.bool.isRequired,
    showForInstitutionsLink: PropTypes.bool.isRequired,
    topbarSearchSubmit: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    externalSignUpLink: PropTypes.string,
    externalLogInLink: PropTypes.string,
    currentUserSubscriptionPlansHasLoaded: PropTypes.bool.isRequired,
    fetchUserSubscriptionPlans: PropTypes.func.isRequired,
  };

  static defaultProps = {
    fixed: true,
    showLoginModal: true,
    externalSignUpLink: null,
    externalLogInLink: null,
  };

  constructor(props) {
    super(props);
    if (props.activeUserId) {
      props.loadCurrentUser();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.activeUserId !== prevProps.activeUserId) {
      this.props.getEnrolledClassData();
    }
  }

  onSaveLanguage = (value) => {
    this.props.onSaveLanguageChoice(this.props.activeUser, value);
  };

  render() {
    // XXX: The mobile app will have a custom user agent. We can use this
    // to hide the top bar (as required by iOS app store rules). See BUFF-2444
    if (this.props.inAppWebview) {
      return null;
    }

    return (
      <ol-top-bar
        class={classnames(topBarContainer, {
          'height-small': this.props.small,
        })}
      >
        <LinkProvider value={Link}>
          <LoginModal />
          <div
            className={classnames('top-bar', {
              'height-small': this.props.small,
              'top-bar-fixed': this.props.fixed,
              'top-bar-with-expanded-menu': !!this.props.expandedMenu,
            })}
          >
            <nav
              role="navigation"
              className={classnames('top-bar-nav', {
                'height-small': this.props.small,
              })}
            >
              {this.props.activeUser && this.props.currentCoursePath && (
                <TopBarLeft />
              )}

              {this.props.currentInstitution &&
              this.props.whiteLabelLogoEnabled &&
              this.props.whiteLabelLogoImageUrl ? (
                <div
                  className={classnames(
                    'top-bar-title',
                    'ol-logo',
                    'ol-logo-white-label'
                  )}
                >
                  <a
                    href={
                      this.props.currentInstitution.get(
                        'whiteLabelLogoImageLink'
                      ) || this.props.currentInstitution.get('url')
                    }
                  >
                    <img
                      className="institution-special-logo"
                      src={this.props.whiteLabelLogoImageUrl}
                      alt=""
                      aria-hidden="true"
                    />
                  </a>
                </div>
              ) : (
                <div className={classnames('top-bar-title', 'ol-logo')}>
                  <RouteLink to={{ type: ROUTE_HOMEPAGE }}>
                    <span className="topbar-icon-ol-logo" aria-hidden="true" />
                    <span className="topbar-icon-ol-brand" aria-hidden="true" />
                    <span className="screen-reader-text">OpenLearning</span>
                  </RouteLink>
                </div>
              )}

              <TopBarRight
                currentCoursePath={this.props.currentCoursePath}
                currentInstitution={this.props.currentInstitution}
                showLoginModal={this.props.showLoginModal}
                cohortsByCourseCreator={this.props.cohortsByCourseCreator}
                isInstitutionAdmin={this.props.isInstitutionAdmin}
                hasFetchedEnrolledClassData={
                  this.props.hasFetchedEnrolledClassData
                }
                hasRequestedEnrolledClassData={
                  this.props.hasRequestedEnrolledClassData
                }
                activeUser={this.props.activeUser}
                activeUserId={this.props.activeUserId}
                onLogin={this.props.onLogin}
                expandedMenu={this.props.expandedMenu}
                small={this.props.small}
                loginLinkAction={this.props.loginLinkAction}
                signupLinkAction={this.props.signupLinkAction}
                updateTopBarSiteNavRendered={
                  this.props.updateTopBarSiteNavRendered
                }
                siteNavRendered={this.props.siteNavRendered}
                showForInstitutionsLink={this.props.showForInstitutionsLink}
                onSaveLanguage={this.onSaveLanguage}
                topbarSearchSubmit={this.props.topbarSearchSubmit}
                t={this.props.t}
                externalSignUpLink={this.props.externalSignUpLink}
                externalLogInLink={this.props.externalLogInLink}
                getEnrolledClassData={this.props.getEnrolledClassData}
                topBarItemVisibilities={this.props.topBarItemVisibilities}
                currentUserSubscriptionPlansHasLoaded={
                  this.props.currentUserSubscriptionPlansHasLoaded
                }
                fetchUserSubscriptionPlans={
                  this.props.fetchUserSubscriptionPlans
                }
              />
            </nav>
          </div>
        </LinkProvider>
      </ol-top-bar>
    );
  }
}

const makeMapStateToProps = () => {
  return (state) => {
    const activeUserId = currentUserIdSelector(state);
    const activeUser = currentUserSelector(state);
    const hasFetchedEnrolledClassData = selectHasFetchedEnrolledClassData(
      state
    );
    const portalInstitution = selectCurrentPortal(state);
    const routeType = selectType(state);
    let cohortsByCourseCreator = null;
    if (hasFetchedEnrolledClassData) {
      cohortsByCourseCreator = selectFilteredCohortsByCreatorOrInstitution(
        state
      );
    }
    return {
      activeUser,
      activeUserId,
      currentCoursePath: selectCurrentCoursePath(state),
      cohortsByCourseCreator,
      currentInstitution: selectCurrentInstitution(state),
      isInstitutionAdmin: selectIsAdminOfCurrentInstitution(state),
      hasFetchedEnrolledClassData,
      small: selectIsInCourse(state),
      currentModuleSet: selectOpenModuleSet(state),
      hasRequestedEnrolledClassData: selectHasRequestedEnrolledClassData(state),
      loginLinkAction: selectLoginLink(state),
      signupLinkAction: selectSignupLink(state),
      isCourseRTL: isCurrentCourseRTLSelector(state),
      expandedMenu: selectTopBarExpandedMenu(state),
      siteNavRendered: selectTopBarSiteNavRendered(state),
      inAppWebview: selectIsInAppWebview(state),
      showForInstitutionsLink: selectShowForInstitutionsLink(state),
      externalSignUpLink: getPortalExternalSignUpLink(
        routeType,
        portalInstitution
      ),
      externalLogInLink: getPortalExternalLogInLink(
        routeType,
        portalInstitution
      ),
      whiteLabelLogoImageUrl: selectCurrentPortalWhiteLabelLogoImageUrl(state),
      whiteLabelLogoEnabled: selectCurrentPortalWhiteLabelLogoEnabled(state),
      topBarItemVisibilities: selectTopBarItemVisibilities(state),
      currentUserSubscriptionPlansHasLoaded: selectCurrentUserSubscriptionPlansHasLoaded(
        state
      ),
    };
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onLogin: (mode) => {
    const afterLogin = () => {
      if (ownProps.reloadOnLogin) {
        window.location.reload();
      }
    };
    dispatch(loginRequired(afterLogin, mode));
  },
  getEnrolledClassData: () => {
    dispatch(getEnrolledClassData());
  },
  loadCurrentUser: () => {
    dispatch(loadCurrentUser());
  },
  retrieveInstitutions: (institutionPaths) =>
    dispatch(retrieveInstitutions(institutionPaths)),
  updateTopBarSiteNavRendered: (rendered) => {
    dispatch(updateTopBarSiteNavRendered(rendered));
  },
  topbarSearchSubmit: (searchString) =>
    dispatch(makeTopbarSearchSubmit(searchString)),
  onSaveLanguageChoice: (user, language) =>
    dispatch(updateUserPreferredLanguage(user, language)),
  fetchUserSubscriptionPlans: () => dispatch(fetchUserSubscriptionPlans()),
});

const OLTopBar = withTranslation('auth')(_OLTopBar);

export const HotConnectedOLTopBar = hot(
  connect(makeMapStateToProps, mapDispatchToProps)(OLTopBar)
);
